/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * agora/v1/user.proto
 * OpenAPI spec version: version not set
 */
import { useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import * as axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import type {
  DeleteUser200,
  ListOrganizationUsersParams,
  ListWorkspaceUsersParams,
  RpcStatus,
  UserServiceCountWorkspaceUsersBody,
  V1CountWorkspaceUsersResponse,
  V1CurrentUserResponse,
  V1ListOrganizationUsersResponse,
  V1ListWorkspaceUsersResponse,
  V1User,
  V1UserBasicInfo,
} from '../models';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> =
  (<T>() => T extends X ? 1 : 2) extends <T>() => T extends Y ? 1 : 2 ? A : B;

type WritableKeys<T> = {
  [P in keyof T]-?: IfEquals<
    { [Q in P]: T[P] },
    { -readonly [Q in P]: T[P] },
    P
  >;
}[keyof T];

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (
  k: infer I,
) => void
  ? I
  : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>]
  ? {
      [P in keyof Writable<T>]: T[P] extends object
        ? NonReadonly<NonNullable<T[P]>>
        : T[P];
    }
  : DistributeReadOnlyOverUnions<T>;

/**
 * @summary Gets the current authenticated user.
This is a singleton resource that represents the currently authenticated user.
 */
export const currentUser = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1CurrentUserResponse>> => {
  return axios.default.get(`/api/v1/me`, options);
};

export const getCurrentUserQueryKey = () => {
  return [`/api/v1/me`] as const;
};

export const getCurrentUserQueryOptions = <
  TData = Awaited<ReturnType<typeof currentUser>>,
  TError = AxiosError<RpcStatus>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof currentUser>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCurrentUserQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof currentUser>>> = ({
    signal,
  }) => currentUser({ signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof currentUser>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CurrentUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof currentUser>>
>;
export type CurrentUserQueryError = AxiosError<RpcStatus>;

export function useCurrentUser<
  TData = Awaited<ReturnType<typeof currentUser>>,
  TError = AxiosError<RpcStatus>,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof currentUser>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof currentUser>>,
          TError,
          Awaited<ReturnType<typeof currentUser>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCurrentUser<
  TData = Awaited<ReturnType<typeof currentUser>>,
  TError = AxiosError<RpcStatus>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof currentUser>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof currentUser>>,
          TError,
          Awaited<ReturnType<typeof currentUser>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCurrentUser<
  TData = Awaited<ReturnType<typeof currentUser>>,
  TError = AxiosError<RpcStatus>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof currentUser>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets the current authenticated user.
This is a singleton resource that represents the currently authenticated user.
 */

export function useCurrentUser<
  TData = Awaited<ReturnType<typeof currentUser>>,
  TError = AxiosError<RpcStatus>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof currentUser>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCurrentUserQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Updates the current authenticated user.
This allows users to update their own profile information.
 */
export const updateCurrentUser = (
  v1User: NonReadonly<V1User>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1User>> => {
  return axios.default.patch(`/api/v1/me`, v1User, options);
};

export const getUpdateCurrentUserMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCurrentUser>>,
    TError,
    { data: NonReadonly<V1User> },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCurrentUser>>,
  TError,
  { data: NonReadonly<V1User> },
  TContext
> => {
  const mutationKey = ['updateCurrentUser'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCurrentUser>>,
    { data: NonReadonly<V1User> }
  > = props => {
    const { data } = props ?? {};

    return updateCurrentUser(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCurrentUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCurrentUser>>
>;
export type UpdateCurrentUserMutationBody = NonReadonly<V1User>;
export type UpdateCurrentUserMutationError = AxiosError<RpcStatus>;

/**
 * @summary Updates the current authenticated user.
This allows users to update their own profile information.
 */
export const useUpdateCurrentUser = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateCurrentUser>>,
      TError,
      { data: NonReadonly<V1User> },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateCurrentUser>>,
  TError,
  { data: NonReadonly<V1User> },
  TContext
> => {
  const mutationOptions = getUpdateCurrentUserMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Lists all users who have access to an organization.
Returns users with organization-level roles, workspace-level roles within the organization,
and organization owners. Each user includes their role information.
 */
export const listOrganizationUsers = (
  organization: string,
  params?: ListOrganizationUsersParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListOrganizationUsersResponse>> => {
  return axios.default.get(`/api/v1/organizations/${organization}/users`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getListOrganizationUsersQueryKey = (
  organization?: string,
  params?: ListOrganizationUsersParams,
) => {
  return [
    `/api/v1/organizations/${organization}/users`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListOrganizationUsersInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof listOrganizationUsers>>,
    ListOrganizationUsersParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params?: ListOrganizationUsersParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listOrganizationUsers>>,
        TError,
        TData,
        QueryKey,
        ListOrganizationUsersParams['page_token']
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListOrganizationUsersQueryKey(organization, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOrganizationUsers>>,
    QueryKey,
    ListOrganizationUsersParams['page_token']
  > = ({ signal, pageParam }) =>
    listOrganizationUsers(
      organization,
      { ...params, page_token: pageParam || params?.['page_token'] },
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!organization,
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listOrganizationUsers>>,
    TError,
    TData,
    QueryKey,
    ListOrganizationUsersParams['page_token']
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListOrganizationUsersInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOrganizationUsers>>
>;
export type ListOrganizationUsersInfiniteQueryError = AxiosError<RpcStatus>;

export function useListOrganizationUsersInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listOrganizationUsers>>,
    ListOrganizationUsersParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params: undefined | ListOrganizationUsersParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listOrganizationUsers>>,
        TError,
        TData,
        QueryKey,
        ListOrganizationUsersParams['page_token']
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganizationUsers>>,
          TError,
          Awaited<ReturnType<typeof listOrganizationUsers>>,
          QueryKey
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListOrganizationUsersInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listOrganizationUsers>>,
    ListOrganizationUsersParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params?: ListOrganizationUsersParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listOrganizationUsers>>,
        TError,
        TData,
        QueryKey,
        ListOrganizationUsersParams['page_token']
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganizationUsers>>,
          TError,
          Awaited<ReturnType<typeof listOrganizationUsers>>,
          QueryKey
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListOrganizationUsersInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listOrganizationUsers>>,
    ListOrganizationUsersParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params?: ListOrganizationUsersParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listOrganizationUsers>>,
        TError,
        TData,
        QueryKey,
        ListOrganizationUsersParams['page_token']
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists all users who have access to an organization.
Returns users with organization-level roles, workspace-level roles within the organization,
and organization owners. Each user includes their role information.
 */

export function useListOrganizationUsersInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listOrganizationUsers>>,
    ListOrganizationUsersParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params?: ListOrganizationUsersParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listOrganizationUsers>>,
        TError,
        TData,
        QueryKey,
        ListOrganizationUsersParams['page_token']
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListOrganizationUsersInfiniteQueryOptions(
    organization,
    params,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListOrganizationUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof listOrganizationUsers>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params?: ListOrganizationUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganizationUsers>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListOrganizationUsersQueryKey(organization, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOrganizationUsers>>
  > = ({ signal }) =>
    listOrganizationUsers(organization, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!organization,
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listOrganizationUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListOrganizationUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOrganizationUsers>>
>;
export type ListOrganizationUsersQueryError = AxiosError<RpcStatus>;

export function useListOrganizationUsers<
  TData = Awaited<ReturnType<typeof listOrganizationUsers>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params: undefined | ListOrganizationUsersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganizationUsers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganizationUsers>>,
          TError,
          Awaited<ReturnType<typeof listOrganizationUsers>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListOrganizationUsers<
  TData = Awaited<ReturnType<typeof listOrganizationUsers>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params?: ListOrganizationUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganizationUsers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganizationUsers>>,
          TError,
          Awaited<ReturnType<typeof listOrganizationUsers>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListOrganizationUsers<
  TData = Awaited<ReturnType<typeof listOrganizationUsers>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params?: ListOrganizationUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganizationUsers>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists all users who have access to an organization.
Returns users with organization-level roles, workspace-level roles within the organization,
and organization owners. Each user includes their role information.
 */

export function useListOrganizationUsers<
  TData = Awaited<ReturnType<typeof listOrganizationUsers>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  params?: ListOrganizationUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganizationUsers>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListOrganizationUsersQueryOptions(
    organization,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Gets basic information about a user in an organization.
 */
export const getUserBasicInfo = (
  organization: string,
  user: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1UserBasicInfo>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/users/${user}`,
    options,
  );
};

export const getGetUserBasicInfoQueryKey = (
  organization?: string,
  user?: string,
) => {
  return [`/api/v1/organizations/${organization}/users/${user}`] as const;
};

export const getGetUserBasicInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserBasicInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  user: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserBasicInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserBasicInfoQueryKey(organization, user);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserBasicInfo>>
  > = ({ signal }) =>
    getUserBasicInfo(organization, user, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && user),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserBasicInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserBasicInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserBasicInfo>>
>;
export type GetUserBasicInfoQueryError = AxiosError<RpcStatus>;

export function useGetUserBasicInfo<
  TData = Awaited<ReturnType<typeof getUserBasicInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  user: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserBasicInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserBasicInfo>>,
          TError,
          Awaited<ReturnType<typeof getUserBasicInfo>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserBasicInfo<
  TData = Awaited<ReturnType<typeof getUserBasicInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  user: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserBasicInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserBasicInfo>>,
          TError,
          Awaited<ReturnType<typeof getUserBasicInfo>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserBasicInfo<
  TData = Awaited<ReturnType<typeof getUserBasicInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  user: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserBasicInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets basic information about a user in an organization.
 */

export function useGetUserBasicInfo<
  TData = Awaited<ReturnType<typeof getUserBasicInfo>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  user: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserBasicInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetUserBasicInfoQueryOptions(
    organization,
    user,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lists all users who have access to a workspace.
Returns users with direct workspace roles and users with organization-level roles
(who have implicit access to all workspaces). Each user includes their role information.
 */
export const listWorkspaceUsers = (
  organization: string,
  workspace: string,
  params?: ListWorkspaceUsersParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListWorkspaceUsersResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/users`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListWorkspaceUsersQueryKey = (
  organization?: string,
  workspace?: string,
  params?: ListWorkspaceUsersParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/users`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListWorkspaceUsersInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof listWorkspaceUsers>>,
    ListWorkspaceUsersParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListWorkspaceUsersParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listWorkspaceUsers>>,
        TError,
        TData,
        QueryKey,
        ListWorkspaceUsersParams['page_token']
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListWorkspaceUsersQueryKey(organization, workspace, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listWorkspaceUsers>>,
    QueryKey,
    ListWorkspaceUsersParams['page_token']
  > = ({ signal, pageParam }) =>
    listWorkspaceUsers(
      organization,
      workspace,
      { ...params, page_token: pageParam || params?.['page_token'] },
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listWorkspaceUsers>>,
    TError,
    TData,
    QueryKey,
    ListWorkspaceUsersParams['page_token']
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListWorkspaceUsersInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listWorkspaceUsers>>
>;
export type ListWorkspaceUsersInfiniteQueryError = AxiosError<RpcStatus>;

export function useListWorkspaceUsersInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listWorkspaceUsers>>,
    ListWorkspaceUsersParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: undefined | ListWorkspaceUsersParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listWorkspaceUsers>>,
        TError,
        TData,
        QueryKey,
        ListWorkspaceUsersParams['page_token']
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWorkspaceUsers>>,
          TError,
          Awaited<ReturnType<typeof listWorkspaceUsers>>,
          QueryKey
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListWorkspaceUsersInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listWorkspaceUsers>>,
    ListWorkspaceUsersParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListWorkspaceUsersParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listWorkspaceUsers>>,
        TError,
        TData,
        QueryKey,
        ListWorkspaceUsersParams['page_token']
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWorkspaceUsers>>,
          TError,
          Awaited<ReturnType<typeof listWorkspaceUsers>>,
          QueryKey
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListWorkspaceUsersInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listWorkspaceUsers>>,
    ListWorkspaceUsersParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListWorkspaceUsersParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listWorkspaceUsers>>,
        TError,
        TData,
        QueryKey,
        ListWorkspaceUsersParams['page_token']
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists all users who have access to a workspace.
Returns users with direct workspace roles and users with organization-level roles
(who have implicit access to all workspaces). Each user includes their role information.
 */

export function useListWorkspaceUsersInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listWorkspaceUsers>>,
    ListWorkspaceUsersParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListWorkspaceUsersParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listWorkspaceUsers>>,
        TError,
        TData,
        QueryKey,
        ListWorkspaceUsersParams['page_token']
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListWorkspaceUsersInfiniteQueryOptions(
    organization,
    workspace,
    params,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListWorkspaceUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof listWorkspaceUsers>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListWorkspaceUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listWorkspaceUsers>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListWorkspaceUsersQueryKey(organization, workspace, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listWorkspaceUsers>>
  > = ({ signal }) =>
    listWorkspaceUsers(organization, workspace, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listWorkspaceUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListWorkspaceUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listWorkspaceUsers>>
>;
export type ListWorkspaceUsersQueryError = AxiosError<RpcStatus>;

export function useListWorkspaceUsers<
  TData = Awaited<ReturnType<typeof listWorkspaceUsers>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: undefined | ListWorkspaceUsersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listWorkspaceUsers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWorkspaceUsers>>,
          TError,
          Awaited<ReturnType<typeof listWorkspaceUsers>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListWorkspaceUsers<
  TData = Awaited<ReturnType<typeof listWorkspaceUsers>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListWorkspaceUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listWorkspaceUsers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWorkspaceUsers>>,
          TError,
          Awaited<ReturnType<typeof listWorkspaceUsers>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListWorkspaceUsers<
  TData = Awaited<ReturnType<typeof listWorkspaceUsers>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListWorkspaceUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listWorkspaceUsers>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists all users who have access to a workspace.
Returns users with direct workspace roles and users with organization-level roles
(who have implicit access to all workspaces). Each user includes their role information.
 */

export function useListWorkspaceUsers<
  TData = Awaited<ReturnType<typeof listWorkspaceUsers>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListWorkspaceUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listWorkspaceUsers>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListWorkspaceUsersQueryOptions(
    organization,
    workspace,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Gets user counts for specified workspaces within an organization.
 */
export const countWorkspaceUsers = (
  organization: string,
  userServiceCountWorkspaceUsersBody: UserServiceCountWorkspaceUsersBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1CountWorkspaceUsersResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces:countUsers`,
    userServiceCountWorkspaceUsersBody,
    options,
  );
};

export const getCountWorkspaceUsersMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof countWorkspaceUsers>>,
    TError,
    { organization: string; data: UserServiceCountWorkspaceUsersBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof countWorkspaceUsers>>,
  TError,
  { organization: string; data: UserServiceCountWorkspaceUsersBody },
  TContext
> => {
  const mutationKey = ['countWorkspaceUsers'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof countWorkspaceUsers>>,
    { organization: string; data: UserServiceCountWorkspaceUsersBody }
  > = props => {
    const { organization, data } = props ?? {};

    return countWorkspaceUsers(organization, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CountWorkspaceUsersMutationResult = NonNullable<
  Awaited<ReturnType<typeof countWorkspaceUsers>>
>;
export type CountWorkspaceUsersMutationBody =
  UserServiceCountWorkspaceUsersBody;
export type CountWorkspaceUsersMutationError = AxiosError<RpcStatus>;

/**
 * @summary Gets user counts for specified workspaces within an organization.
 */
export const useCountWorkspaceUsers = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof countWorkspaceUsers>>,
      TError,
      { organization: string; data: UserServiceCountWorkspaceUsersBody },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof countWorkspaceUsers>>,
  TError,
  { organization: string; data: UserServiceCountWorkspaceUsersBody },
  TContext
> => {
  const mutationOptions = getCountWorkspaceUsersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary TODO: Can we replace this with deactivate user
Soft delete the user
 */
export const deleteUser = (
  user: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DeleteUser200>> => {
  return axios.default.delete(`/api/v1/users/${user}`, options);
};

export const getDeleteUserMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUser>>,
    TError,
    { user: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteUser>>,
  TError,
  { user: string },
  TContext
> => {
  const mutationKey = ['deleteUser'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteUser>>,
    { user: string }
  > = props => {
    const { user } = props ?? {};

    return deleteUser(user, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteUser>>
>;

export type DeleteUserMutationError = AxiosError<RpcStatus>;

/**
 * @summary TODO: Can we replace this with deactivate user
Soft delete the user
 */
export const useDeleteUser = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteUser>>,
      TError,
      { user: string },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteUser>>,
  TError,
  { user: string },
  TContext
> => {
  const mutationOptions = getDeleteUserMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
